export const createMeta = vm => ({
  title: vm.$t('waiting.seo.ovo.title', { storeName: vm.storeInfo?.name }),
  meta: {
    pageTitle: { name: 'Page Title', content: vm.$t('waiting.seo.ovo.pageTitle', { storeName: vm.storeInfo?.name }), },
  },
})
